import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SubPageReviseIcon = ({
  icon,
  tooltip,
  isDisabled,
  handleClick,
  additionalStyles = ""
}) => {
  return (
    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
      <FontAwesomeIcon
        size="lg"
        icon={icon}
        onClick={handleClick}
        className={`ms-1 cursor-pointer ${
          additionalStyles ? additionalStyles : ""
        } ${isDisabled ? "pe-none text-secondary" : ""}`}
      />
    </OverlayTrigger>
  );
};
export default SubPageReviseIcon;
